import { config, vueConfig, setThemeConfig } from '@/config'
import themeConfig from '../config'
import svgs from '../svg'
import '@/default'

setThemeConfig(themeConfig)
Object.assign(vueConfig.registerGlobalsComponentMap, svgs)
